import { cAPI } from '../../../utils/cAPI';

import { getData, addEditData, removeData } from '../generic';

export const getServices = searchConfig => dispatch => getData(dispatch, cAPI.APGetServicesSearchResult, searchConfig, ['services']);
export const deleteService = id => async dispatch => await removeData(dispatch, cAPI.APDeleteProduct, id, 'services');
export const updateServiceStatus = formData => dispatch => addEditData(dispatch, cAPI.APUpdateProductStatus, formData, 'services');